import { createContext, useContext, useEffect, useState } from "react";
import localStorageKey from "../../../enumerations/localStorageKey";
import { useGetNotice } from "../../../hooks/notice/notice.hook";
import { useTikTokPixel } from "../../../hooks/tiktokPixel/tiktokPixel.hooks";
import { DailyCheckPopup, DepositMessage, EventPopup, MarqueePopup } from "../components";

const PopupContext = createContext({
  sorting: 1,
  setNextSorting: () => {},
  data: null,
});
export const PopupContextProvider = ({ children }) => {
  const { trackEvent, isHaveTikTokPixel } = useTikTokPixel();
  const [sorting, setSorting] = useState(1);
  const { isError, error, data } = useGetNotice({
    enabled: !!window.localStorage.getItem(localStorageKey.DEFAULT_CURRENCY),
    staleTime: 60 * (60 * 1000), //60mins
    cacheTime: 60 * (60 * 1000), //60mins
  });

  useEffect(() => {
    // console.debug("sorting", sorting);
  }, [sorting]);

  const setNextSorting = () => {
    setSorting((prev) => (prev += 1));
  };

  useEffect(() => {
    if (isHaveTikTokPixel) {
      trackEvent({
        eventName: "Home",
      });
    }
  }, [isHaveTikTokPixel, trackEvent]);

  return (
    <PopupContext.Provider value={{ sorting, setNextSorting, data }}>
      {children}
      <EventPopup />
      <DailyCheckPopup />
      <MarqueePopup />
      <DepositMessage />
    </PopupContext.Provider>
  );
};
export const usePopupContext = () => {
  const PopupContextValue = useContext(PopupContext);
  return PopupContextValue;
};
